document.addEventListener('DOMContentLoaded',()=>{
  const btn=document.querySelector('[data-menu-toggle]');
  const menu=document.querySelector('[data-mobile-menu]');
  if(btn&&menu){
    const closeMenu=()=>{
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden','true');
      menu.inert=true;
      btn.setAttribute('aria-expanded','false');
      btn.setAttribute('aria-label','Open menu');
    };
    btn.addEventListener('click',()=>{
      const isOpen=menu.classList.toggle('is-open');
      menu.setAttribute('aria-hidden',String(!isOpen));
      menu.inert=!isOpen;
      btn.setAttribute('aria-expanded',String(isOpen));
      btn.setAttribute('aria-label',isOpen?'Close menu':'Open menu');
    });
    menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
    document.addEventListener('keydown',event=>{if(event.key==='Escape')closeMenu();});
    window.matchMedia('(max-width: 800px)').addEventListener('change',event=>{if(!event.matches)closeMenu();});
  }

  const mobileGallery=window.matchMedia('(max-width: 640px)');
  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-gallery-track]');
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    if(!track||!slides.length)return;

    let activeId=String(slides.find(slide=>slide.classList.contains('is-active'))?.dataset.gallerySlide||slides[0].dataset.gallerySlide);
    let scrollFrame;
    const activate=(id,scrollToSlide=false)=>{
      activeId=String(id);
      slides.forEach(slide=>{
        const active=String(slide.dataset.gallerySlide)===activeId;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',mobileGallery.matches?'false':String(!active));
        if(active&&scrollToSlide&&mobileGallery.matches){
          track.scrollTo({left:slide.offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        }
      });
      thumbs.forEach(thumb=>{
        const active=String(thumb.dataset.galleryThumb)===activeId;
        thumb.classList.toggle('is-active',active);
        if(active)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');
      });
    };

    thumbs.forEach(thumb=>thumb.addEventListener('click',()=>activate(thumb.dataset.galleryThumb,true)));
    track.addEventListener('scroll',()=>{
      if(!mobileGallery.matches)return;
      cancelAnimationFrame(scrollFrame);
      scrollFrame=requestAnimationFrame(()=>{
        const nearest=slides.reduce((best,slide)=>Math.abs(slide.offsetLeft-track.scrollLeft)<Math.abs(best.offsetLeft-track.scrollLeft)?slide:best,slides[0]);
        activate(nearest.dataset.gallerySlide);
      });
    },{passive:true});
    mobileGallery.addEventListener('change',()=>activate(activeId));
    activate(activeId);
  });

  document.querySelectorAll('[data-quantity-selector]').forEach(selector=>{
    const input=selector.querySelector('input[type="number"]');
    if(!input)return;
    selector.querySelectorAll('[data-quantity-change]').forEach(button=>button.addEventListener('click',()=>{
      const minimum=Number(input.min)||1;
      input.value=String(Math.max(minimum,(Number(input.value)||minimum)+Number(button.dataset.quantityChange)));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
  });

  document.querySelectorAll('[data-product-variant]').forEach(select=>{
    const form=select.closest('form');
    const price=form?.closest('.product-detail__info')?.querySelector('[data-product-price]');
    const addButton=form?.querySelector('[data-add-to-cart]');
    const addText=form?.querySelector('[data-add-to-cart-text]');
    const updateVariant=()=>{
      const option=select.selectedOptions[0];
      if(!option)return;
      const available=option.dataset.available==='true';
      if(price&&option.dataset.price)price.textContent=option.dataset.price;
      if(addButton)addButton.disabled=!available;
      if(addText)addText.textContent=available?'Add to Cart':'Sold Out';
    };
    select.addEventListener('change',updateVariant);
    updateVariant();
  });
  const initSummonedGalleries=(root=document)=>{
    const hoverCapable=window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('[data-summoned-gallery]').forEach(gallery=>{
      if(gallery.dataset.summonedReady==='true')return;
      const images=[...gallery.querySelectorAll('.summoned-card__image')];
      if(images.length<2)return;

      gallery.dataset.summonedReady='true';
      let index=0;
      let delayTimer;
      let intervalTimer;

      const show=(nextIndex)=>{
        index=nextIndex;
        images.forEach((image,imageIndex)=>image.classList.toggle('is-active',imageIndex===index));
      };

      const stop=()=>{
        clearTimeout(delayTimer);
        clearInterval(intervalTimer);
        delayTimer=undefined;
        intervalTimer=undefined;
        show(0);
      };

      const start=()=>{
        if(!hoverCapable.matches||reduceMotion.matches)return;
        clearTimeout(delayTimer);
        clearInterval(intervalTimer);
        delayTimer=setTimeout(()=>{
          show((index+1)%images.length);
          intervalTimer=setInterval(()=>show((index+1)%images.length),1150);
        },520);
      };

      gallery.addEventListener('pointerenter',start);
      gallery.addEventListener('pointerleave',stop);
      hoverCapable.addEventListener('change',event=>{if(!event.matches)stop();});
      reduceMotion.addEventListener('change',event=>{if(event.matches)stop();});
    });
  };

  initSummonedGalleries();
  document.addEventListener('shopify:section:load',event=>initSummonedGalleries(event.target));

});
